import { React, useState } from "react";
import "./css/input.css";

function Input({ onSubmitValue, isLoading }) {
  const [inputValue, setInputValue] = useState("");

  function submit(event) {
    event.preventDefault();
    if (inputValue.trim() !== "" && !isLoading) {
      onSubmitValue(inputValue);
      setInputValue("");
    }
  }

  function handleChange(event) {
    setInputValue(event.target.value);
  }

  return (
    <div className="input-container">
      <form className="search-bar" autoComplete="off" onSubmit={submit}>
        <input
          id="messageBox"
          type="text"
          placeholder="Ask about a movie, product, or web series..."
          onChange={handleChange}
          value={inputValue}
          disabled={isLoading}
        />
        <div className="action-area">
          <button
            id="sendButton"
            className={inputValue.trim() !== "" ? "active" : ""}
            type="submit"
            disabled={inputValue.trim() === "" || isLoading}
          >
            <img
              src={
                inputValue.trim() !== ""
                  ? "./Assets/up-arrow-hover.png"
                  : "./Assets/up-arrow.png"
              }
              alt="Send"
            />
          </button>
        </div>
      </form>
    </div>
  );
}

export default Input;
